"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var numberToCurrency = num => !num || Number.isNaN(num) || num === 0 ? null : num.toLocaleString('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0
});
var _default = exports.default = numberToCurrency;